import axiosInstance from "./AxiosInstance";

export const fetchPatientReviewList = () => {
  return axiosInstance.post(
    "/patient/ReviewTestimonialProvidedList",
    { }
  );
};